import type { ComponentProps } from 'react';
import { Space } from '../../space';

export type FormLayoutProperties = ComponentProps<typeof Space>;

const FormLayout = (props: FormLayoutProperties) => <Space block orientation="vertical" size="small" {...props} />;

export default FormLayout;
